import { Box, Button, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import { Sensors, SensorsOff } from '@mui/icons-material';

export const ESTADO_HABILITADO = 'habilitada';
export const ESTADO_DESABILITADO = 'desabilitada';

class ToggleAtualizacaoInformacoesProcesso extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            handleChange: action,
            tooltipSwitchAtualizacaoInformacoesProcesso: computed,
            tooltipSwitchAlertaNovasInformacoes: computed
        });
    }

    handleChange() {
        if (this.sessaoStore.atualizacaoInformacoesProcessoHabilitada === false) {
            this.salaSessaoStore.recarregarListaProcessos();
        }
        const novoEstado = !this.sessaoStore.atualizacaoInformacoesProcessoHabilitada;
        this.sessaoStore.atualizacaoInformacoesProcessoHabilitada = novoEstado;
        this.sessaoStore.alertaNovasInformacoesProcessoNaoAtualizadas = false;
        sessionStorage.setItem(
            'atualizacaoInformacoesProcessoHabilitada',
            novoEstado ? ESTADO_HABILITADO : ESTADO_DESABILITADO
        );
    }

    get tooltipSwitchAtualizacaoInformacoesProcesso() {
        let msg = this.sessaoStore.atualizacaoInformacoesProcessoHabilitada ? 'Desabilitar' : 'Habilitar';
        msg += ' atualização automática de informações dos processos';

        return msg;
    }

    get tooltipSwitchAlertaNovasInformacoes() {
        if (this.sessaoStore.alertaNovasInformacoesProcessoNaoAtualizadas) {
            return 'Alerta: Novas atualizações disponíveis.';
        }

        return '';
    }

    render() {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip
                    title={
                        <>
                            <Typography>{this.tooltipSwitchAtualizacaoInformacoesProcesso}</Typography>
                            <Typography>{this.tooltipSwitchAlertaNovasInformacoes}</Typography>
                        </>
                    }
                    placement="top-start"
                >
                    <Button
                        color={this.sessaoStore.atualizacaoInformacoesProcessoHabilitada ? 'inherit' : 'primary'}
                        sx={{ minWidth: 'auto' }}
                        onClick={this.handleChange.bind(this)}
                    >
                        {this.sessaoStore.atualizacaoInformacoesProcessoHabilitada ? (
                            <Sensors color="primary" />
                        ) : (
                            <SensorsOff
                                color={
                                    this.sessaoStore.alertaNovasInformacoesProcessoNaoAtualizadas
                                        ? 'warning'
                                        : 'disabled'
                                }
                            />
                        )}
                    </Button>
                </Tooltip>
            </Box>
        );
    }
}

export default inject('stores')(observer(ToggleAtualizacaoInformacoesProcesso));
